














import { Prop, Component, Vue } from 'vue-property-decorator'

export type DropCallback = (event: DragEvent, position: number) => void

@Component
export default class ListDropzone extends Vue {
    @Prop({ type: Function }) readonly dropCallback!: DropCallback
    @Prop({ type: Number }) readonly position!: number
    dragOver = false
    dragOverTimeout = null

    get classes(): object {
        return {
            'list-dropzone': true,
            'list-dropzone--dragover': this.dragOver,
        }
    }

    dragOverHandler(event: DragEvent) {
        event.preventDefault()
        event.dataTransfer.dropEffect = 'move'

        if (this.dragOverTimeout !== null) {
            clearTimeout(this.dragOverTimeout)
            this.dragOverTimeout = null
        }

        this.dragOver = true
        this.dragOverTimeout = setTimeout(() => {
            this.dragOver = false
            this.dragOverTimeout = null
        }, 100)
    }

    dropHandler(event: DragEvent) {
        this.dropCallback(event, this.position)
        this.dragOver = false
    }
}
